import React, { useState, useEffect } from 'react';
import { Database, Cpu, Users, PieChart, Brain } from 'lucide-react';

// Frases por tipo de carga
const loadingPhrases = {
  forecast: [
    "Conectando con la base de datos...",
    "Cargando historial de 36 meses...",
    "Preparando features para XGBoost...",
    "Entrenando modelo XGBoost...",
    "Ejecutando Prophet...",
    "Combinando predicciones...",
    "Calculando intervalos de confianza...",
    "Generando forecast final..."
  ],
  clients: [
    "Conectando con la base de datos...",
    "Cargando cartera de clientes...",
    "Procesando historial de volúmenes...",
    "Calculando estados de semáforo...",
    "Obteniendo datos de ejecutivos...",
    "Preparando vista..."
  ],
  executives: [
    "Conectando con la base de datos...",
    "Cargando equipo de ventas...",
    "Calculando KPIs por ejecutivo...",
    "Obteniendo clientes asignados...",
    "Preparando vista..."
  ],
  coverage: [
    "Conectando con la base de datos...",
    "Analizando participación de mercado...",
    "Calculando share of wallet...",
    "Identificando potencial sin capturar...",
    "Preparando análisis..."
  ],
  model: [
    "Conectando con la base de datos...",
    "Cargando especificaciones del modelo...",
    "Obteniendo parámetros técnicos...",
    "Preparando documentación..."
  ],
  default: [
    "Conectando con la base de datos...",
    "Cargando información...",
    "Procesando datos...",
    "Preparando vista..."
  ]
};

// Íconos por tipo
const iconsByType = {
  forecast: Brain,
  clients: Users,
  executives: Users,
  coverage: PieChart,
  model: Cpu,
  default: Database
};

// Componente base del loader unificado
const LoaderComponent = ({ type = "default", customPhrases = null }) => {
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const phrases = customPhrases || loadingPhrases[type] || loadingPhrases.default;
  const Icon = iconsByType[type] || iconsByType.default;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhrase((prev) => (prev + 1) % phrases.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [phrases.length]);

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      {/* Icon with spinner */}
      <div className="relative mb-6">
        <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-violet-600 rounded-2xl flex items-center justify-center shadow-lg">
          <Icon className="w-8 h-8 text-white" />
        </div>
        <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow-md">
          <div className="w-4 h-4 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
      
      {/* Phrase with fade animation */}
      <div className="h-6 flex items-center justify-center">
        <p 
          key={currentPhrase}
          className="text-sm font-medium text-slate-600 animate-fade-in text-center"
        >
          {phrases[currentPhrase]}
        </p>
      </div>

      {/* Model badges for forecast type */}
      {type === 'forecast' && (
        <div className="flex gap-2 mt-4">
          <span className="px-3 py-1 bg-indigo-50 text-indigo-600 rounded-full text-xs font-medium border border-indigo-200">
            XGBoost v3.2
          </span>
          <span className="px-3 py-1 bg-emerald-50 text-emerald-600 rounded-full text-xs font-medium border border-emerald-200">
            Prophet v1.3
          </span>
        </div>
      )}
    </div>
  );
};

// Named exports
export function DataLoader(props) {
  return <LoaderComponent type={props.type || "default"} customPhrases={props.customPhrases} />;
}

export function ForecastLoader(props) {
  return <LoaderComponent type="forecast" customPhrases={props.customPhrases} />;
}

// Default export
export default DataLoader;
